import React, { useEffect, useState } from "react";
import DashboardHeader from "../../../../components/header/DashboardHeader";
import "../createGroup/CreateGroup.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  CommonSelect,
  Input,
  LoadingButton,
  Select,
  TextArea,
} from "../../../../components/header/form";
import { imageHandler } from "../../../../utils/imageHandler";
import { edit_icon, img_placehlder, upload_cover } from "../../../../assets";
import { createGroupApi } from "../../../../services/groups";
import { generateFormDataPayload } from "../../../../utils/sendMultipartDataHelper";
import {
  childGroupMemberListAPi,
  fetchCategoriesListApi,
} from "../../../../services/common";
import { toastMessage } from "../../../../utils/toastMessage";
import { CiNoWaitingSign } from "react-icons/ci";
import { useSelector } from "react-redux";
import { havePermission } from "../../../../utils/commonHelper";

const CreateChildrenGroup = () => {
  let adminId = useLocation().state;
  adminId = adminId?.length ? adminId : [];
  const { parentGroupId } = useParams();
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [admin, setAdmin] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [inputData, setInputData] = useState({ _parent: parentGroupId });
  const [buttonDisabledButton, setDisabledButton] = useState(true);
  const { showAuth } = useSelector((state) => state?.showAuth);
  const [image, setImage] = useState("");
  const navigate = useNavigate();

  //---------handle-change-------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value.replace(/^\s+/, "") });
  };

  const addGroupHandler = async () => {
    if (!image || (!image.name && typeof image !== "string")) {
      return toastMessage(
        "Please upload a cover image",
        "error",
        "coverImageCreateSubGroup"
      );
    }
    try {
      const payload = { ...inputData, _user: inputData?._user?.length ? inputData?._user?.map(user => user.value) : [showAuth?._id] }
      setLoading(true);
      const formData = new FormData();
      formData.append("coverImage", image);
      generateFormDataPayload(formData, payload);

      const { data } = await createGroupApi(formData);
      const { success, message } = data;
      if (success) {
        navigate(-1);
      }
      toastMessage(message, success ? "success" : "error", "addGroupHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };

  // ------------- validation------------
  const isFormComplete = () => {
    const requiredFields = ["name", "categoryName", "type", "description"];
    if (havePermission(adminId, showAuth)) {
      requiredFields.push("_user"); // Add `_user` field if the condition is true
    }
    const isAllFilled = requiredFields.every((field) =>
      String(inputData[field] || "")
    );
    if (inputData.type === "SUBSCRIPTION") {
      const subscriptionFields = [
        "monthlyPrice",
        "quarterlyPrice",
        "yearlyPrice",
      ];
      return (
        isAllFilled &&
        subscriptionFields?.every((field) =>
          String(inputData[field] || "")?.trim()
        )
      );
    }
    return isAllFilled;
  };
  // console.log('inputData edit', inputData)
  useEffect(() => {
    setDisabledButton(!isFormComplete());
  }, [inputData]);

  const fetchCategoryList = async () => {
    try {
      const { data } = await fetchCategoriesListApi();
      const { success, data: response } = data;
      if (success) {
        setCategoryList(response);
      } else {
        setCategoryList([]);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  useEffect(() => {
    const fetchMemberList = async () => {
      try {
        const { data } = await childGroupMemberListAPi({ _id: parentGroupId });
        const { success, data: response } = data;
        if (success) {
          setMemberList(response);
        } else {
          setMemberList([]);
        }
      } catch (e) {
        console.log("Error:-", e.message);
      }
    };
    fetchMemberList();
    fetchCategoryList();
  }, [parentGroupId]);
  return (
    <>
      <div className="create_group">
        <DashboardHeader title={"Groups"} />

        <div className="dashboard_pages">
          <div className="create_group_page">
            <div className="create_grp_Navbar">
              <nav className="breadcrumb_wrap">
                <ul>
                  <li>
                    <Link to={-1}>Groups </Link>
                  </li>
                  <li>Create a Group</li>
                </ul>
              </nav>
            </div>

            <div className="upload_cover">
              <div className="upload_design">
                <label className="user_icon" htmlFor="file_picker">
                  <div className="upload_design_content">
                    <img
                      src={
                        (image?.name && URL.createObjectURL(image)) ||
                        upload_cover
                      }
                      alt=""
                    />
                    <div className="upload_design_text">
                      <h3>Upload Cover</h3>
                      <span>(JPG, GIF, PNG. Max size of 800K)</span>
                    </div>
                  </div>
                  <input
                    type="file"
                    id="file_picker"
                    accept="image/*"
                    onChange={(e) => imageHandler(e, setImage, "image", null)}
                  />
                  <label
                    htmlFor="profile_picture"
                    className="edit-icon"
                  ></label>
                </label>
              </div>

              <div className="form_field_wrap">
                <div className="form_field">
                  <Input
                    required
                    label="Group Name"
                    type="text"
                    id="name"
                    name="name"
                    value={inputData?.name}
                    onChange={handleChange}
                    className="input form-control"
                    placeholder="Enter Group Name"
                  />
                </div>

                <div className="form_field">
                  {/* <Input
                    required
                    label="Category"
                    type="text"
                    id="categoryName"
                    name="categoryName"
                    placeholder="Enter category name"
                    value={inputData?.categoryName}
                    onChange={handleChange}
                    className="input form-control"
                  /> */}
                  <Select
                    label="Category"
                    type="text"
                    id="categoryName"
                    name="categoryName"
                    value={inputData?.categoryName}
                    onChange={handleChange}
                    className="input form-control"
                  >
                    <option value="">Select Category</option>
                    {categoryList?.map((data, ind) => (
                      <option key={ind} value={data?.name}>{data?.name}</option>
                    ))}
                  </Select>
                </div>

                <div className="form_field">
                  <Select
                    label="Group Type"
                    type="text"
                    id="groupType"
                    name="type"
                    value={inputData?.type}
                    onChange={handleChange}
                    className="input form-control"
                  >
                    <option value={""}>Group Type</option>
                    <option value={"PRIVATE"}>Private</option>
                    <option value={"PUBLIC"}>Public</option>
                    <option value={"SUBSCRIPTION"}>Subscription</option>
                  </Select>
                </div>
              </div>
              {/* {adminId && havePermission(adminId, showAuth) && (
                <div className="form_field_wrap">
                  <div className="form_field">
                    <Select
                      label="Assign Admin"
                      type="text"
                      id="groupType"
                      name="_user"
                      value={inputData?._user}
                      onChange={handleChange}
                      className="input form-control"
                    >
                      <option value="">Assign admin</option>
                      {memberList && memberList.length > 0 ? (
                        memberList.map((data, ind) => (
                          <option key={ind} value={data?._user?._id}>
                            {data?._user?.fullName}
                          </option>
                        ))
                      ) : (
                        <option value="" disabled>
                          No Admin
                        </option>
                      )}
                    </Select>
                  </div>
                </div>
              )} */}

              {
                (adminId?.length &&
                  havePermission(adminId, showAuth)) &&
                (
                  <div className="form-group">
                    <CommonSelect
                      isMulti
                      label={"Assign Group Admin"}
                      value={inputData?._user}
                      options={memberList.map(user => ({ label: user._user.fullName, value: user._user._id }))}
                      onChange={e => setInputData({ ...inputData, _user: e })}
                    />
                  </div>
                )
              }

              {/* -------------if-subscription------------------- */}
              {inputData?.type === "SUBSCRIPTION" && (
                <>
                  <div className="form_field_wrap">
                    <div className="form_field">
                      <Input
                        required
                        label="Monthly"
                        type="text"
                        id="monthly"
                        name="monthlyPrice"
                        value={inputData?.monthlyPrice}
                        onChange={handleChange}
                        className="input form-control"
                        placeholder="Enter enter monthly"
                      />
                    </div>

                    <div className="form_field">
                      <Input
                        required
                        label="Quarterly"
                        type="text"
                        id="quarterly"
                        name="quarterlyPrice"
                        value={inputData?.quarterlyPrice}
                        onChange={handleChange}
                        className="input form-control"
                        placeholder="Enter enter quarterly"
                      />
                    </div>

                    <div className="form_field">
                      <Input
                        required
                        label="Yearly"
                        type="text"
                        id="yearly"
                        name="yearlyPrice"
                        value={inputData?.yearlyPrice}
                        onChange={handleChange}
                        className="input form-control"
                        placeholder="Enter enter yearly"
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="form_field textarea">
                <TextArea
                  label="Description"
                  type="text"
                  id="description"
                  name="description"
                  value={inputData?.description}
                  onChange={handleChange}
                  className="input form-control"
                  placeholder="Write here..."
                  // error={error?.nickname}
                  rows="6"
                />
              </div>
            </div>

            <div className="create_grp_btn">
              <LoadingButton
                loading={loading}
                isDisabled={buttonDisabledButton}
                className={buttonDisabledButton ? "cstm_disabled_btn" : ""}
                onClick={addGroupHandler}
              >
                Create Group
                {/* {buttonDisabledButton ? <CiNoWaitingSign /> : "Create Group"} */}
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateChildrenGroup;
